import l from "@babel/runtime/helpers/esm/objectSpread2";
import { sstyled as c } from "@semcore/utils/lib/core/index";
import { createBaseComponent as s, sstyled as j, assignProps as f } from "@semcore/core";
import h from "react";
import { Box as d } from "@semcore/flex-box";
import { useColorResolver as p } from "@semcore/utils/lib/use/useColorResolver";
var z = (
  /*__reshadow_css_start__*/
  (c.insert(
    /*__inner_css_start__*/
    '.___SText_bjxob_gg_{padding:0;margin:0}.___SText_bjxob_gg_._size_100_bjxob_gg_{font-size:var(--intergalactic-fs-100, 12px);line-height:var(--intergalactic-lh-100, 133%)}.___SText_bjxob_gg_._size_200_bjxob_gg_{font-size:var(--intergalactic-fs-200, 14px);line-height:var(--intergalactic-lh-200, 142%)}.___SText_bjxob_gg_._size_300_bjxob_gg_{font-size:var(--intergalactic-fs-300, 16px);line-height:var(--intergalactic-lh-300, 150%)}.___SText_bjxob_gg_._size_400_bjxob_gg_{font-size:var(--intergalactic-fs-400, 20px);line-height:var(--intergalactic-lh-400, 120%)}.___SText_bjxob_gg_._size_500_bjxob_gg_{font-size:var(--intergalactic-fs-500, 24px);line-height:var(--intergalactic-lh-500, 117%)}.___SText_bjxob_gg_._size_600_bjxob_gg_{font-size:var(--intergalactic-fs-600, 32px);line-height:var(--intergalactic-lh-600, 125%)}.___SText_bjxob_gg_._size_700_bjxob_gg_{font-size:var(--intergalactic-fs-700, 36px);line-height:var(--intergalactic-lh-700, 110%)}.___SText_bjxob_gg_._size_800_bjxob_gg_{font-size:var(--intergalactic-fs-800, 48px);line-height:var(--intergalactic-lh-800, 117%)}.___SText_bjxob_gg_.__noWrap_bjxob_gg_{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.___SText_bjxob_gg_.__medium_bjxob_gg_{font-weight:var(--intergalactic-medium, 500)}.___SText_bjxob_gg_.__semibold_bjxob_gg_{font-weight:var(--intergalactic-semi-bold, 600)}.___SText_bjxob_gg_.__bold_bjxob_gg_{font-weight:var(--intergalactic-bold, 700)}.___SText_bjxob_gg_.__italic_bjxob_gg_{font-style:italic}.___SText_bjxob_gg_.__monospace_bjxob_gg_{font-family:Consolas,"Roboto Mono",Menlo,Courier,monospace}.___SText_bjxob_gg_.__uppercase_bjxob_gg_{text-transform:uppercase}.___SText_bjxob_gg_.__lowercase_bjxob_gg_{text-transform:lowercase}.___SText_bjxob_gg_.__capitalize_bjxob_gg_{text-transform:capitalize}.___SText_bjxob_gg_.__decoration_bjxob_gg_{-webkit-text-decoration:var(--decoration_bjxob);text-decoration:var(--decoration_bjxob)}.___SText_bjxob_gg_.__color_bjxob_gg_{color:var(--color_bjxob)}.___SText_bjxob_gg_.__fontSize_bjxob_gg_{font-size:var(--fontSize_bjxob)}.___SText_bjxob_gg_.__lineHeight_bjxob_gg_{line-height:var(--lineHeight_bjxob)}.___SText_bjxob_gg_.__fontWeight_bjxob_gg_{font-weight:var(--fontWeight_bjxob)}.___SText_bjxob_gg_.__textAlign_bjxob_gg_{text-align:var(--textAlign_bjxob)}.___SText_bjxob_gg_._use_primary_bjxob_gg_{color:var(--intergalactic-text-primary, #191b23)}.___SText_bjxob_gg_._use_secondary_bjxob_gg_{color:var(--intergalactic-text-secondary, #6c6e79)}.___SText_bjxob_gg_.__disabled_bjxob_gg_{opacity:var(--intergalactic-disabled-opacity, 0.3)}',
    "bjxob_gg_"
  ), {
    __SText: "___SText_bjxob_gg_",
    _size_100: "_size_100_bjxob_gg_",
    _size_200: "_size_200_bjxob_gg_",
    _size_300: "_size_300_bjxob_gg_",
    _size_400: "_size_400_bjxob_gg_",
    _size_500: "_size_500_bjxob_gg_",
    _size_600: "_size_600_bjxob_gg_",
    _size_700: "_size_700_bjxob_gg_",
    _size_800: "_size_800_bjxob_gg_",
    _noWrap: "__noWrap_bjxob_gg_",
    _medium: "__medium_bjxob_gg_",
    _semibold: "__semibold_bjxob_gg_",
    _bold: "__bold_bjxob_gg_",
    _italic: "__italic_bjxob_gg_",
    _monospace: "__monospace_bjxob_gg_",
    _uppercase: "__uppercase_bjxob_gg_",
    _lowercase: "__lowercase_bjxob_gg_",
    _capitalize: "__capitalize_bjxob_gg_",
    _decoration: "__decoration_bjxob_gg_",
    "--decoration": "--decoration_bjxob",
    _color: "__color_bjxob_gg_",
    "--color": "--color_bjxob",
    _fontSize: "__fontSize_bjxob_gg_",
    "--fontSize": "--fontSize_bjxob",
    _lineHeight: "__lineHeight_bjxob_gg_",
    "--lineHeight": "--lineHeight_bjxob",
    _fontWeight: "__fontWeight_bjxob_gg_",
    "--fontWeight": "--fontWeight_bjxob",
    _textAlign: "__textAlign_bjxob_gg_",
    "--textAlign": "--textAlign_bjxob",
    _use_primary: "_use_primary_bjxob_gg_",
    _use_secondary: "_use_secondary_bjxob_gg_",
    _disabled: "__disabled_bjxob_gg_"
  })
);
function m(_, e) {
  if (_)
    return "underline";
  if (e)
    return "line-through";
}
function g(_, e) {
  var t = arguments[0], o, i = d, b = _.color, a = _.underline, x = _.lineThrough, r = m(a, x), n = p();
  return o = j(z), /* @__PURE__ */ h.createElement(i, o.cn("SText", l({}, f({
    tag: "span",
    "data-ui-name": "Text",
    ref: e,
    "use:decoration": r,
    "use:color": n(b)
  }, t))));
}
g.displayName = "Text";
const W = s(g);
export {
  W as default
};
